import RepairFileDetail from '@/views/restricted/repair-file-module/folder-lifecycle/RepairFileDetail.vue'
import DistributorLayout from '@/layouts/DistributorLayout.vue'
import EstimatePackageClientOptionSelected
  from '@/views/public-access/repair-module/EstimatePackageClientOptionSelected.vue'
import EstimateRepairerClientOptionSelected
  from '@/views/public-access/repair-module/EstimateRepairerClientOptionSelected.vue'
import RepairFileAddAttachmentPage from '@/views/public-access/repair-module/RepairFileAddAttachmentPage.vue'
import RepairFileUploadAdditionalAttachmentPage
  from '@/views/public-access/repair-module/RepairFileUploadAdditionalAttachmentPage.vue'

export default [
  {
    path: '/repair-file-detail/:repairFileBoomerangId',
    name: 'RepairFileDetail',
    component: RepairFileDetail,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_ADD_REPAIR_FILE']

    }
  },
  {
    path: '/public/client-package-select',
    name: 'EstimatePackageClientOptionSelected',
    component: EstimatePackageClientOptionSelected,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/public/client-option-select',
    name: 'EstimateRepairerClientOptionSelected',
    component: EstimateRepairerClientOptionSelected,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/public/repair-file/add-attachment',
    name: 'RepairFileAddAttachmentPagePage',
    component: RepairFileAddAttachmentPage,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/public/repair-file/upload-additional-attachment',
    name: 'RepairFileUploadAdditionalAttachmentPage',
    component: RepairFileUploadAdditionalAttachmentPage,
    meta: {
      requiresAuth: false
    }
  }
]
